import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import type { OverviewCategory, OverviewSubCategory } from 'shared/src/api';

export const useLogClickIconList = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (subCategory: OverviewSubCategory, category: OverviewCategory) => {
      logAnalyticsEvent({
        name: 'CLICK_ICON_LIST',
        analytics: {
          ...subCategory.logging.analytics,
          CATEGORY_NAME: category.item.name,
          CATEGORY_SNO: category.item.sno,
        },
      });
    },
    [logAnalyticsEvent],
  );
};
